





































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import moment from "moment";
import MyDateTimePickerMobile from "../common/MyDateTimePickerMobile.vue";

@Component({
  components: {
    MyDateTimePickerMobile,
  },
})
export default class TreatmentRequestFilterModalClone extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;
  @Prop({ type: Object, required: true }) readonly searchParam!: any;
  @Prop({ type: Array, default: () => [] }) readonly techniqueOptions!: any[];

  dialog = this.value;
  isValid = true;
  pagingOption: any = { page: 1 };

  filters = {
    keyword: "",
    technique: "",
    status: "",
    dateFrom: "",
    dateTo: "",
  };

  // Define statusOptions locally with translations
  get statusOptions() {
    return [
      { value: "", name: this.$t("text.all") },
      { value: "In Request", name: this.$t("text.inRequest") },
      { value: "In Progress", name: this.$t("text.inProgress") },
      { value: "Finished", name: this.$t("text.finished") },
      { value: "Cancelled", name: this.$t("text.cancelled") },
    ];
  }

  @Watch("value")
  onValueChange(val: boolean): void {
    this.dialog = val;
    if (val) {
      this.filters = { ...this.searchParam };
    }
  }

  @Watch("dialog")
  onDialogChange(val: boolean): void {
    this.$emit("input", val);
  }

  closeModal(): void {
    this.dialog = false;
  }

  onSearch(): void {
    this.$emit("apply-filters", { ...this.filters });
    this.closeModal();
  }

  clearAndClose(): void {
    this.$set(this.filters, "technique", "");
    this.$set(this.filters, "status", "");
    this.$set(this.filters, "dateFrom", "");
    this.$set(this.filters, "dateTo", "");
    this.$emit("apply-filters", { ...this.filters });
    this.closeModal();
  }

  applyFilters(): void {
    this.$emit("apply-filters", { ...this.filters });
    this.closeModal();
  }

  get isFilterApplied(): boolean {
    const { technique, status, dateFrom, dateTo } = this.searchParam;
    return (
      (technique && technique !== 0 && technique !== "") ||
      (status && status !== "") ||
      (dateFrom && dateFrom !== "") ||
      (dateTo && dateTo !== "")
    );
  }
}
